import { Box, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import Header from '../../components/special/Header';
import DashboardTimeWeek from '../../components/dashboard-modules/DashboardTimeWeek';
import { useTranslation } from 'react-i18next';
import { generateMediaQuerysForDashboardGrid } from '../../components/dashboard-modules/dashboardGridManagement';
import { DashboardUpcomingEvents } from '../../components/dashboard-modules/DashboardUpcomingEvents';
import DashboardUserTasks from '../../components/dashboard-modules/DashboardUserTasks';
import DashboardAllTodos from '../../components/dashboard-modules/DashboardAllTodos';
import { DashboardGant } from '../../components/dashboard-modules/DashboardGant';
import { hasPermissions } from '../../auth/hasPermissions';
import { useDashboardResponsive } from '../../components/dashboard-modules/useDashboardResponsive';

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const { isMobile, getModuleProps, shouldShowGantt } =
    useDashboardResponsive();

  const mediaQuery = generateMediaQuerysForDashboardGrid();

  const eventsProps = getModuleProps(1, 1);
  const tasksProps = getModuleProps(1, 2);
  const todosProps = getModuleProps(2, 2);
  const timeProps = getModuleProps(1, 1);
  const ganttProps = getModuleProps(4, 2);

  return (
    <Box className="h-full flex flex-col w-full overflow-y-auto">
      <Header title={t('Dashboard')} />
      <Box className="grid px-2 md:px-4 gap-3 sm:gap-4" sx={mediaQuery}>
        <DashboardUpcomingEvents {...eventsProps} />
        <DashboardUserTasks {...tasksProps} />
        {hasPermissions('project', 'read') && (
          <DashboardAllTodos {...todosProps} />
        )}
        {hasPermissions('time-tracking', 'read') && (
          <DashboardTimeWeek {...timeProps} />
        )}
        {hasPermissions('project', 'read') && shouldShowGantt && (
          <DashboardGant {...ganttProps} />
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;
